<template>
  <button :disabled="disabled || $store.state.loading" class="aoform__btn" :class="{'aoform__btn_nodecor': nodecor, 'aoform__btn_right': toright}">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    disabled: {type: Boolean, default: false},
    nodecor: {type: Boolean, default: false},
    toright: {type: Boolean, default: false}
  }
}
</script>

<style lang="sass">
.aoform__btn
  width: fit-content
  font-weight: 500
  font-size: 14px
  line-height: 24px
  position: relative
  z-index: 1
  white-space: nowrap
  cursor: pointer
  padding: 17px 32px 15px
  border: 2px solid colors.$red
  border-radius: 64px
  background: none
  overflow: hidden
  &[disabled]
    pointer-events: none
    opacity: .4
    color: colors.$font
  &::before
    content: ""
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: -40px
    z-index: -1
    width: calc(100% + 54px)
    transform: skew(45deg) translateX(-100%)
    background-color: colors.$red
    transition: transform .2s ease-out
    transform-origin: 0 0
  &:hover
    color: colors.$notred
  &:hover::before
    transform: skew(45deg)
  .aoform__btn-underlined
    border-bottom: 1px dashed colors.$red
  &_nodecor
    border: none
    margin-left: -32px
    margin-right: -32px
    &:hover
      color: colors.$font
    &::before
      display: none
  &_right    
    margin-left: auto      
  @include from(breakpoints.$formMob)
    width: 100%
    margin-left: 0
    margin-right: 0
</style>